import { createSlice } from "@reduxjs/toolkit";

const initialState = {};

const studygrouppriceSlice = createSlice({
  name: "studygroupprice",
  initialState,
  // reducers: {},
});

// export const { userLoggedIn, userLoggedOut } = userSlice.actions
export default studygrouppriceSlice.reducer;
